import React, { useState } from 'react';
import { Paper, Button, withStyles, InputLabel, Grid, Select, MenuItem, Dialog } from '@material-ui/core';
import SearchForm from './SearchForm';
import { chassisType, BackButton } from '../../../sc-utilities'
import * as actions from '../../store/profileActions';
import { connect } from 'react-redux';
import TypicalProblemModal from "./TypicalProblemModal";
import AppLogoLoading from '../../../sc-logo';

const styles = theme => ({
    root: {
        width: `97.3%`,
        height: 'auto',
        padding: theme.spacing(),
        margin: '10px',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    grid: {
        padding: theme.spacing(),
    },
    button: {
        margin: "2px"
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden"
    },
    logo: {
        width: '250px',
        margin: '10px'
    }
});

const TypicalProblems = props => {
    const { classes, activeCustomerID, translations, onFetchPCTypicalProblems } = props;
    const [typicalProblems, setTypicalProblems] = useState({ original: [], searched: [], loading: true, type: '', loadingLogo: false, hotKey: [] });
    const [typicalProblemsModal, setTypicalProblemsModal] = useState({ open: false, data: {} });

    const handleChange = async event => {
        setTypicalProblems({ ...typicalProblems, loadingLogo: true })
        let data = {};
        data['ActiveCustomerID'] = activeCustomerID;
        data['type'] = event && event.target && event.target.value ? event.target.value : typicalProblems.type;
        let typicalProblem = await onFetchPCTypicalProblems(data);
        setTypicalProblems({ ...typicalProblems, original: typicalProblem, searched: typicalProblem, loading: false, type: data.type, loadingLogo: false });
    }

    const handleOpen = data => {
        setTypicalProblemsModal({ open: true, data: data })
    }

    const handleSearch = async (searchState, data) => {
        let searchedOriginal = data ? data : typicalProblems.original;
        let searched = [];
        let allKey = [];

        for (const typicalProblem of searchedOriginal) {
            if (searchState.showOnlyDefault && !typicalProblem.default) {
                continue;
            }
            if (searchState.showOnlyFavorite && !typicalProblem.favorite) {
                continue;
            }
            if (typicalProblem.hotKey) {
                allKey.push(typicalProblem.hotKey.split('+')[1]);
            }
            if (searchState.showOnlyWithHotKey && !typicalProblem.hotKey) {
                continue;
            }
            if (searchState.search && typicalProblem.label.toLowerCase().includes(searchState.search.toLowerCase())) {
                searched.push(typicalProblem);
                continue;
            }
            if (searchState.search) {
                continue;
            }
            searched.push(typicalProblem);
        }
        setTypicalProblems({ ...typicalProblems, searched: searched, hotKey: allKey });
    }

    return (
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <Grid container spacing={1} direction="column" className={classes.grid} >
                <InputLabel shrink>{translations['choose_chassis_type'] || "Choose chassis type"}</InputLabel>
                <Select
                    name="chassis_type"
                    label={translations['choose_chassis_type'] || 'Choose chassis type'}
                    margin="dense"
                    fullWidth={true}
                    defaultValue={''}
                    onChange={handleChange}
                >
                    {chassisType(translations).map(type => {
                        return (
                            <MenuItem key={type.key} value={type.key}>
                                {type.value}
                            </MenuItem>
                        )
                    })}
                </Select>
                {!typicalProblems.loading ? <>
                    <SearchForm handleChange={handleSearch} search={typicalProblems} translations={translations} />
                    <Grid container direction="row">
                        {typicalProblems.searched.map((data, index) => (
                            <Button
                                variant="outlined"
                                color="primary"
                                key={data.value}

                                className={classes.button}
                                value={data.value}
                                margin={'dense'}
                                onClick={() => handleOpen(data)}
                            >
                                {data.label}</Button>
                        ))}
                    </Grid> </> : null}
            </Grid>
            {typicalProblemsModal.open ? <TypicalProblemModal search={typicalProblems} handleFilter={handleChange} handleSearch={handleSearch} modalState={typicalProblemsModal} handleCloseSafe={() => setTypicalProblemsModal({ open: false, data: [] })} /> : null}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={typicalProblems.loadingLogo}
                PaperProps={{
                    classes: {
                        root: classes.paper
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
        </Paper>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchPCTypicalProblems: params => dispatch(actions.fetchTypicalProblems(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TypicalProblems));

